import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { yellow } = colors

const CircleQuestion = (props: Icon) => {
    const {
        color = 'white',
        background = yellow,
        size = 40,
        className = 'circle-question'
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    fill={background}
                />
                <path
                    fill={color}
                    d="M19.902 26.05a1.475 1.475 0 1 1 0 2.95 1.475 1.475 0 0 1 0-2.95zm.056-1.476c-.822 0-1.49-.673-1.49-1.503 0-2 1.754-3.522 3.468-4.748.534-.382 1.122-1.646.793-2.683-.326-1.023-1.616-1.633-2.675-1.633h-.002c-1.162 0-2.603.545-3.165 2.072a1.487 1.487 0 0 1-1.916.885 1.505 1.505 0 0 1-.877-1.932c.901-2.448 3.24-4.032 5.958-4.032h.003c2.151 0 4.735 1.277 5.513 3.72.75 2.361-.405 4.98-1.907 6.053-1.997 1.428-2.213 2.083-2.213 2.298 0 .83-.667 1.503-1.49 1.503z"
                />
            </g>
        </svg>
    )
}

export { CircleQuestion }
